import type * as React from "react";

export type PickerRawItem = object | string | number | null | undefined;

export interface NormalizedPickerOption {
  value: string;
  label: string;
  raw: PickerRawItem;
}

export function normalizePickerData(
  data: PickerRawItem[] | undefined,
  labelKey = "label",
  valueKey = "value"
): NormalizedPickerOption[] {
  if (!data?.length) return [];

  return data
    .map((item): NormalizedPickerOption | null => {
      if (item === null || item === undefined) return null;

      if (typeof item === "string" || typeof item === "number") {
        const serialized = String(item);
        return { value: serialized, label: serialized, raw: item };
      }

      const record = item as Record<string, unknown> & object;
      const rawValue = record[valueKey] ?? record.value ?? record.label;
      const rawLabel = record[labelKey] ?? record.label ?? rawValue;

      if (rawValue === null || rawValue === undefined) return null;

      return {
        value: String(rawValue),
        label: String(rawLabel ?? rawValue),
        raw: item,
      };
    })
    .filter((option): option is NormalizedPickerOption => option !== null);
}

export function findPickerOption(
  options: NormalizedPickerOption[],
  value: string | null | undefined
) {
  if (value === null || value === undefined || value === "") return undefined;
  return options.find((option) => option.value === String(value));
}

export function resolvePickerLabel(
  option: NormalizedPickerOption | undefined,
  renderMenuItem?: (
    label: React.ReactNode,
    item: PickerRawItem,
    selected?: boolean
  ) => React.ReactNode,
  selected?: boolean
) {
  if (!option) return null;
  if (renderMenuItem) {
    return renderMenuItem(option.label, option.raw, selected);
  }
  return option.label;
}
